import { Repository } from 'src/components/types';

export type Segment = {
  match?: boolean;
  text: string;
};

export type Line = {
  line: number;
  segments: Segment[];
};

export type Hunk = {
  lines: Line[];
};

export type Commit = {
  hash: string;
  repository: Repository & {
    mainbranch?: {
      name?: string;
    };
  };
};

export type CodeSearchResult = {
  file: {
    path: string;
    commit: Commit;
  };
  content_matches: Hunk[];
  content_match_count: number;
  path_matches: Segment[];
};

export enum SearchErrorKey {
  QueryWithoutTerms = 'QUERY_WITHOUT_TERMS',
  QueryWithoutPositiveTerms = 'QUERY_WITHOUT_POSITIVE_TERMS',
  SearchNotEnabled = 'SEARCH_NOT_ENABLED',
}

export type SearchError = {
  error: {
    message: string;
    data: {
      key?: SearchErrorKey;
    };
  };
};

export function isSearchError(
  response: SearchResponse
): response is SearchError {
  return (response as SearchError).error !== undefined;
}

export const isSearchNotInstalled = (response: SearchResponse) => {
  return (
    (response as SearchError)?.error?.data?.key ===
    SearchErrorKey.SearchNotEnabled
  );
};

export type SearchResults = {
  page: number;
  pagelen: number;
  query_substituted: boolean;
  size: number;
  values: CodeSearchResult[];
};

export type SearchResponse = SearchResults | SearchError | null;

export type SearchQueryParams = {
  account?: string;
  q?: string;
  page?: number;
  extra?: {
    modifiersOnly?: boolean;
    source?: 'searchResultsScreen' | 'repositorySourceSearchResultsScreen';
  };
};
